module.exports = __webpack_public_path__ + "static/p8-5afbafcbd93fea925994096a47a2226a.jpg";